module.exports = __webpack_public_path__ + "img/export2212.bc39df3f.svg";